/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Ce_DeclarationInputs */

const de_commons_footer_ce_declaration = /** @type {(inputs: Commons_Footer_Ce_DeclarationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CE-Deklaration`)
};

/** @type {(inputs: Commons_Footer_Ce_DeclarationInputs) => LocalizedString} */
const en_commons_footer_ce_declaration = de_commons_footer_ce_declaration;

/**

* @param {Commons_Footer_Ce_DeclarationInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_ce_declaration = /** @type {((inputs?: Commons_Footer_Ce_DeclarationInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Ce_DeclarationInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_ce_declaration(inputs)
	return en_commons_footer_ce_declaration(inputs)
});